import React, { Component } from "react";
import gql from "graphql-tag";
import gsap from "gsap";
import { graphql } from "react-apollo";
import { Link } from "react-router-dom";

const GOLDEN_RATIO = (1 + Math.sqrt(5)) / 2;
const RECIPROCAL_GR = 1 / GOLDEN_RATIO;
const DURATION = RECIPROCAL_GR;

class Profile extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    if (this.props.data.profile) {
      const mainInner = document.querySelector(".pageTransition__slide");
      gsap.to(mainInner, {
        autoAlpha: 1,
        duration: DURATION,
        ease: "sine.out",
      });
    }
  }

  render() {
    const props = this.props;
    if (!props.data.profile) {
      return <p className="hidden">Loading...</p>;
    }
    return (
      <div
        className={
          "pageTransition__slide pageTransition__slide--child bg-brand-maroon"
        }
      >
        <section className="grid grid-cols-1 lg:grid-cols-2 team-grid h-full bg-white min-h-screen">
          <div className="row-start-2 lg:row-start-1 lg:row-end-3 col-auto">
            {props.data.profile.featuredImage.node.sourceUrl ? (
              <img
                src={props.data.profile.featuredImage.node.sourceUrl}
                alt={props.data.profile.featuredImage.node.sourceUrl}
                className="object-cover w-full h-full"
              />
            ) : null}
          </div>
          <div className="lg:row-span-1 lg:border-b border-brand-maroon flex justify-between items-center p-brand-6 lg:p-brand-12 bg-white max-h-brand-16 lg:max-h-auto ">
            {props.data.profile.featuredImage.node.sourceUrl ? (
              <h1 className="text-black uppercase text-brand-2xl lg:text-brand-4xl leading-tight">
                {props.data.profile.title}
              </h1>
            ) : null}

            <Link to={"/portfolio"} className="cursor-pointer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="none"
                className="w-5 xl:w-8 stroke-current text-brand-black"
                viewBox="0 0 26 26"
              >
                <path
                  stroke="currentColor"
                  strokeWidth="1.5"
                  d="M0 -0.75L33.951 -0.75"
                  transform="matrix(.7071 .7071 -.64087 .76765 1 2)"
                ></path>
                <path
                  stroke="currentColor"
                  strokeWidth="1.5"
                  d="M0 -0.75L33.941 -0.75"
                  transform="matrix(.7071 -.7071 .64087 .76765 1 26)"
                ></path>
              </svg>
            </Link>
          </div>
          <div className="lg:row-start-2 lg:row-end-3 p-brand-6 lg:p-brand-12 bg-white relative ">
            <div className="flex mb-brand-12">
              <div className="w-6/12">
                <p className="mb-2 text-brand-maroon uppercase section-title">Founder</p>
                {props.data.profile.portfolio.founder ? (
                  <p className="text-lg mb-0 lg:text-brand-2xl leading-tight">
                    {props.data.profile.portfolio.founder}
                  </p>
                ) : null}
              </div>
              <div className="w-6/12 lg:pl-2">
                <p className="mb-2 text-brand-maroon uppercase section-title">Website</p>
                {props.data.profile.portfolio.website ? (
                  <a
                    href={props.data.profile.portfolio.website.url}
                    className="text-brand-blood-orange text-lg lg:text-brand-2xl leading-tight brand-link"
                    target={props.data.profile.portfolio.website.target}
                  >
                    {props.data.profile.portfolio.website.title}
                  </a>
                ) : null}
              </div>
            </div>
            {props.data.profile.portfolioCategories && props.data.profile.portfolioCategories.nodes.length > 0 ? (
              <div className="mb-brand-12">
                <p className="mb-2 text-brand-maroon uppercase section-title">Industry Tags</p>
                <ul className="flex flex-wrap">
                  {props.data.profile.portfolioCategories.nodes.map((cat) => {
                    if(cat.name.toLowerCase() !== "spotlight"){
                      return(
                    <li key={`${cat.name}-${cat.id}`}>
                      <Link
                        to={`/portfolio?cat=${cat.name}`}
                        className="text-brand-maroon mr-2 cat uppercase roundedmr-1 text-brand-s mb-5 border rounded-full py-2 px-3 cat uppercase text-brand-maroon-pointer">
                        {cat.name}
                      </Link>
                    </li>
                      )
                    }
                  })}
                </ul>
              </div>
            ):null}
            
            <p className="mb-2 text-brand-maroon uppercase section-title">Company Bio</p>
            {props.data.profile.content ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: props.data.profile.content,
                }}
              ></div>
            ) : null}
            {props.data.profile.portfolio.additionalLinks && props.data.profile.portfolio.additionalLinks.length > 0 ? (
              props.data.profile.portfolio.additionalLinks.map((additionalLink) => {
                const link = additionalLink.additionalLink;
                return (
                  <div className="block my-brand-8" key={`${link.url}-lnk`}>
                  <a
                    href={(link.url) ? link.url : props.data.profile.portfolio.website.url}
                    className="justify-end items-center  w-auto  lg:inline-flex lg:basis-full brand-link text-brand-blood-orange"
                    target={(link.target) ? link.target : '_self'}
                  >
                    <span>{(link.title) ? link.title : "Media/press"}</span>
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    fill="none"
                    stroke="currentColor"
                    className="ml-3 hover:text-brand-blood-orange  "
                    viewBox="0 0 22 22"
                  >
                    <path
                      strokeWidth="1.5"
                      className="text-brand-blood-orange"
                      d="M0 10.738h20.3M9.8 20.475l10.5-9.737L9.8 1"
                    ></path>
                  </svg>
                  </a>
                  </div>
                );
              })
            ) : null}
            {/* {props.data.profile.portfolio.website || props.data.profile.portfolio.additionalLink ? (
                  <a
                    href={(props.data.profile.portfolio.additionalLink && props.data.profile.portfolio.additionalLink.url) ? props.data.profile.portfolio.additionalLink.url : props.data.profile.portfolio.website.url}
                    className="justify-end items-center  w-auto  my-brand-8 lg:inline-flex brand-link text-brand-blood-orange"
                    target={(props.data.profile.portfolio.additionalLink && props.data.profile.portfolio.additionalLink.target) ? props.data.profile.portfolio.additionalLink.target: '_self'}
                  >
                    <span>{(props.data.profile.portfolio.additionalLink && props.data.profile.portfolio.additionalLink.title) ? props.data.profile.portfolio.additionalLink.title : "Media/press"}</span>
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    fill="none"
                    stroke="currentColor"
                    className="ml-3 hover:text-brand-blood-orange  "
                    viewBox="0 0 22 22"
                  >
                    <path
                      strokeWidth="1.5"
                      className="text-brand-blood-orange"
                      d="M0 10.738h20.3M9.8 20.475l10.5-9.737L9.8 1"
                    ></path>
                  </svg>
                  </a>
                ) : null} */}
            {/* {props.data.profile.portfolio.website ? (
                  <a
                    href={props.data.profile.portfolio.website.url}
                    className="justify-end items-center  w-auto  my-brand-8 lg:inline-flex brand-link text-brand-blood-orange"
                    target={props.data.profile.portfolio.website.target}
                  >
                    <span>{props.data.profile.portfolio.linkText || "Media/press"}</span>
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    fill="none"
                    stroke="currentColor"
                    className="ml-3 hover:text-brand-blood-orange  "
                    viewBox="0 0 22 22"
                  >
                    <path
                      strokeWidth="1.5"
                      className="text-brand-blood-orange"
                      d="M0 10.738h20.3M9.8 20.475l10.5-9.737L9.8 1"
                    ></path>
                  </svg>
                  </a>
                ) : null} */}
          </div>
        </section>
      </div>
    );
  }
}

const GetProfileBySlug = gql`
  query getProfileBySlug($slug: String) {
    profile: profileBy(uri: $slug) {
      title
      portfolio {
        founder
        website {
          title
          target
          url
        }
        additionalLinks {
          additionalLink {
            title
            target
            url
          }
        }
      }
      portfolioCategories {
        nodes {
          name
        }
      }
      content
      featuredImage {
        node {
          altText
          sourceUrl
        }
      }
    }
  }
`;

export default graphql(GetProfileBySlug, {
  options: (props) => {
    const slug = props.match.params.slug;
    return {
      variables: {
        slug,
      },
    };
  },
})(Profile);



// WEBPACK FOOTER //
// ./scripts/components/Portfolio/Profile.jsx